const ROLE_CLAIM_CANDIDATES = [
  'role',
  'Role',
  'perfil',
  'profile',
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
]

const ROLE_ID_CLAIM_CANDIDATES = [
  'role_id',
  'roleId',
  'RoleId',
  'perfil_id',
  'profile_id',
]

function decodeBase64Url(value) {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/')
  const normalized = `${base64}${'='.repeat((4 - (base64.length % 4)) % 4)}`

  if (typeof window === 'undefined' || typeof window.atob !== 'function') {
    return ''
  }

  return decodeURIComponent(Array.from(window.atob(normalized), (char) => {
    const hex = char.charCodeAt(0).toString(16).padStart(2, '0')
    return `%${hex}`
  }).join(''))
}

export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null

  const parts = token.split('.')
  if (parts.length !== 3) return null

  try {
    const decoded = decodeBase64Url(parts[1])
    return decoded ? JSON.parse(decoded) : null
  } catch {
    return null
  }
}

function getFirstClaim(payload, keys) {
  if (!payload) return null

  for (const key of keys) {
    const value = payload[key]
    if (value !== undefined && value !== null && value !== '') {
      return value
    }
  }

  return null
}

export function extractRoleClaimsFromToken(token) {
  const payload = decodeJwtPayload(token)
  if (!payload) {
    return { role: null, roleId: null, claims: null }
  }

  const role = getFirstClaim(payload, ROLE_CLAIM_CANDIDATES)
  const roleIdRaw = getFirstClaim(payload, ROLE_ID_CLAIM_CANDIDATES)
  const roleId = roleIdRaw === null ? null : Number(roleIdRaw)

  return {
    role: role ? String(role) : null,
    roleId: Number.isFinite(roleId) ? roleId : null,
    claims: payload,
  }
}

export function normalizeRoleName(role) {
  if (!role) return 'LAWYER'

  const normalized = String(role).trim().toUpperCase()

  if (['SUPER_ADMIN'].includes(normalized)) return 'SUPER_ADMIN'
  if (['ADMIN'].includes(normalized)) return 'ADMIN'
  if (['LAWYER'].includes(normalized)) return 'LAWYER'
  if (['ASSISTANT', 'SECRETARY'].includes(normalized)) return 'ASSISTANT'
  if (['FINANCIAL'].includes(normalized)) return 'FINANCIAL'

  return normalized
}

export function sanitizeText(value, fallback = '') {
  if (typeof value !== 'string') return fallback

  return Array.from(value)
    .filter((char) => {
      const code = char.charCodeAt(0)
      return code >= 32 && code !== 127
    })
    .join('')
    .replace(/[<>]/g, '')
    .trim()
}
